<div class="modal-header">
  <h4 class="modal-title">Uredi Izdelek</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  <form>
    <div class="mb-3">
      <label for="name" class="form-label">Ime</label>
      <input type="text" id="name" class="form-control" [(ngModel)]="product.name" name="name">
    </div>
    <div class="mb-3">
      <label for="description" class="form-label">Opis</label>
      <textarea class="form-control" id="description" name="productDescription" [(ngModel)]="product.description" name="productDescription"></textarea>
    </div>
    <div class="mb-3">
      <label for="productImage" class="form-label">Slika izdelka (dovoljeni formati: jpg, jpeg, png)</label>
      <input type="file" id="productImage" class="form-control" (change)="onImageUploadChanged($event)" accept="image/*">
      <!-- Display image preview if available -->
      <div *ngIf="imagePreview" class="mt-2">
        <img [src]="imagePreview" alt="Image Preview" class="img-thumbnail" style="max-width: 100px;">
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">Prekliči</button>
  <button type="button" class="btn btn-primary" (click)="save()">Shrani</button>
</div>
